import React, { useCallback, useEffect, useState } from 'react';

import { useObserver } from 'mobx-react';
import SpinnerWrapper from '@bringg/react-components/dist/components/spinner/spinner';
import { BringgException } from '@bringg/dashboard-sdk/dist/Core/BringgException';
import { withErrorBoundary } from '@bringg-frontend/bringg-web-infra';
import { useWebhooksApiStore, withWebhooksApiStore } from '@bringg-frontend/webhooks-api-internal-stores';
import { Notification } from '@bringg/react-components';
import { useHasFeatureFlag } from '@bringg-frontend/hooks';

import WebhooksTable from '../webhooks-table/webhooks-table';
import WebhooksHeaders from '../webhooks-headers/webhooks-headers';

import '../webhooks.scss';

const WebhookSettings: React.FC = () => {
	const { webhooksAppStore, webhookAuthenticationConfigurationStore } = useWebhooksApiStore();
	const [isLoaded, setLoaded] = useState(false);
	const isWACAPIOAuthEnabled = useHasFeatureFlag('enable_wac_api_oauth');

	const fetchConfiguration = useCallback(async () => {
		try {
			await webhooksAppStore.fetchConfiguration();
			if (!webhooksAppStore.isApplicationInstalled) {
				await webhooksAppStore.installApp();
				await webhooksAppStore.fetchConfiguration();
			}

			setLoaded(true);
		} catch (error) {
			console.error(`failed to load webhook settings: ${(error as BringgException).message}`, error);
			Notification.error('Failed to load webhook settings');
		}
	}, [webhooksAppStore]);

	const fetchWebhookAuthenticationConfiguration = useCallback(async () => {
		await webhookAuthenticationConfigurationStore.fetchAll(isWACAPIOAuthEnabled);
	}, [webhookAuthenticationConfigurationStore, isWACAPIOAuthEnabled]);

	useEffect(() => {
		void fetchConfiguration();
		void fetchWebhookAuthenticationConfiguration();
	}, [webhooksAppStore, fetchConfiguration, webhooksAppStore, fetchWebhookAuthenticationConfiguration]);

	return useObserver(() => {
		if (!isLoaded) {
			return <SpinnerWrapper className="spinner-center" />;
		}

		return (
			<div className="webhooks-container">
				<WebhooksHeaders />
				<WebhooksTable />
			</div>
		);
	});
};

export default withErrorBoundary(withWebhooksApiStore(WebhookSettings));
